import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  CircularProgress,
  Box,
  Typography
} from '@mui/material';
import { resetServicePassword } from '../../services/serviceManagementService';

const ResetPasswordDialog = ({ open, onClose, service }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSendResetEmail = async () => {
    if (!service?.email) {
      setError('Email du service non disponible');
      return;
    }
    
    try {
      setLoading(true);
      setError('');
      
      await resetServicePassword(service.email);
      
      setSuccess(true);
      
      // Fermer le dialogue après 3 secondes
      setTimeout(() => {
        onClose();
        setSuccess(false);
      }, 3000);
    } catch (error) {
      console.error('Erreur lors de l\'envoi de l\'email de réinitialisation:', error);
      setError(error.message || 'Erreur lors de l\'envoi de l\'email de réinitialisation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={loading ? null : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Réinitialiser le mot de passe
      </DialogTitle>
      <DialogContent>
        {success ? (
          <Alert severity="success" sx={{ mt: 2 }}>
            Un email de réinitialisation a été envoyé à {service?.email}. Veuillez vérifier la boîte de réception du service.
          </Alert>
        ) : (
          <Box sx={{ mt: 2 }}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            
            <Typography variant="subtitle1" gutterBottom>
              Service: {service?.name} ({service?.email})
            </Typography>
            
            <Typography variant="body1" sx={{ mt: 2 }}>
              Un email de réinitialisation de mot de passe sera envoyé à l'adresse email du service. 
              Le service pourra alors définir un nouveau mot de passe en suivant les instructions dans l'email.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {success ? 'Fermer' : 'Annuler'}
        </Button>
        {!success && (
          <Button 
            onClick={handleSendResetEmail} 
            variant="contained" 
            color="primary" 
            disabled={loading}
          >
            {loading ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                Envoi en cours...
              </>
            ) : (
              'Envoyer l\'email de réinitialisation'
            )}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ResetPasswordDialog;
